import user from '@/stores/user';

export default function useConnectWallet() {
    const { address, connected } = user;

    function connectWallet() {
        user.toggleConnectModal();
    }

    return {
        connectWallet,
        walletAddress: address,
        connected,
    };
}
